
import { View } from 'backbone';
import util from 'util/Util.js';
import nameTemplate from 'report/properties/main/filter-override.ejs';


class MainFilterOverrideView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = nameTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' :'updateFilterOverride'
        };

        //this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateFilterOverride(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        let propVal = ev.currentTarget.checked;

        if(propName === "additiveDynamicFilter"){
            propVal = !propVal;
        }

        this.model.set( propName, propVal );
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        let bOverridePreviousFilter = util.isTrue(this.model.get('additiveDynamicFilter'));
        $(`input[name='additiveDynamicFilter']`).prop('checked', bOverridePreviousFilter );

        this.delegateEvents();
        return this;
    }

}

export default MainFilterOverrideView;
